export default {
  index: {
    tsevents:"Latest Activity",
    education:"Education",
    charity:"Public Welfare And Charity",
    viewdetails:"View Details",
    homepage:"Home Page",
    breadcrumbtitle:'Music Director',
    aboutus:"About Us",
    contactus:'Contact Us',
    copyright:'Bay Area Orchestra. All Rights Reserved',
    back:'Back',
    adminlogin:'Admin Login',
    title:'Greater Bay Philharmonic Orchestra',
    privacypolicy:'Disclaimer Clause',
    disclaimerclause:'Privacy Policy',
    termsconditionsuse:'Terms And Conditions Of Use',
  },
}

